import apiCore from '../../utils/api-core';

// Intent dictionary API (ADR-033). gohire-admin for read/replace; resolve is any user.
const scopePath = (companyId) => (companyId ? `/api/v3/admin/intents/company/${companyId}` : '/api/v3/admin/intents');

export function getIntents(companyId) {
    return apiCore.get(scopePath(companyId));
}
export function putIntents(companyId, phrases) {
    return apiCore.put(scopePath(companyId), { phrases });
}
// { text } → { norm, intents }; { filters:[..] } → per-filter tokens/intents/redundancy + ambiguity
export function resolveIntent(body) {
    return apiCore.post('/api/v3/intents/resolve', body);
}
export function getCompanies() {
    return apiCore.get('/api/v1/companies');
}
